import React, { Component } from 'react';
import { Container, Navbar, NavbarBrand, Collapse, Nav, NavbarToggler } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
        <header>
            <Navbar style={{height: '7vh'}} className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                
                    <NavbarBrand tag={Link} to="/"><img src="/bikepedcounters/Seal_of_the_City_of_Charlottesville,_VA.png" alt="Charlottesville City Seal" width="60" height="50" /> <span style={{ marginLeft: 10 }}>Charlottesville Bicycle and Pedestrian Count Data</span></NavbarBrand>
                    <NavbarToggler onClick={this.toggleNavbar} className='mr-2'/>
                    <Collapse isOpen={this.state.collapsed} navbar>
                        <Nav className='mr-auto' navbar>
                        </Nav>
                        <span className='navbar-text'><a className='btn btn-outline-info' target="_blank" style={{ color: '#17a2b8'}} href='https://opendata.charlottesville.org'>See the data</a></span>
                    </Collapse>
        </Navbar>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js